module.exports = __webpack_public_path__ + "img/locking_illustration_step_4.4800eff.png";